import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import Raven from "raven-js";
import createRavenMiddleware from "raven-for-redux";

Raven.config(process.env.REACT_APP_NODE_SENTRY).install()

export function configureStore(initialState = {}) {
  const store = createStore(
    reducers,
    initialState,
    composeWithDevTools(
      applyMiddleware(
        thunk,
        createRavenMiddleware(Raven)
      )
    )
  )
  return store;
};

export const store = configureStore();



// WEBPACK FOOTER //
// ./src/store/index.js